export default __webpack_public_path__ + "static/media/bag-delete.f31bc0d1.png";